import Image from 'next/image';
import Link from 'next/link';

import { colors, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { RichText } from 'prismic-reactjs';
import { FormattedDate } from 'react-intl';
import useSWR from 'swr';

import { CardProduct } from '@/src/components/organisms';
import { nextAPIfetcher } from '@/src/lib/utils';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    border: `1px solid ${colors.grey[200]}`,
    borderRadius: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  },
  gridItem: {
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${colors.grey[200]}`,
    '&:last-child': {
      marginBottom: 0,
      borderBottom: 0,
      paddingBottom: 0,
    },
  },
  cardProduct: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    borderRadius: 0,
    '& .card-product__media': {
      width: 100,
      height: 100,
    },
    '& .card-product__content': {
      width: 'calc(100% - 100px)',
      padding: 0,
      paddingLeft: theme.spacing(2),
    },
  },
  blogTitle: {
    fontWeight: 500,
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3),
    },
  },
  image: {
    borderRadius: theme.shape.borderRadius,
  },
}));

export default function Latest() {
  const classes = useStyles();

  const { data } = useSWR(`/blog/posts/latest?pageSize=3`, nextAPIfetcher);

  const { results = [] } = data || {};

  return (
    <div className={classes.root}>
      <Typography
        variant="h6"
        component="div"
        color="textPrimary"
        gutterBottom
        className={classes.sectionTitle}>
        Últimos artigos
      </Typography>
      <Grid container spacing={0}>
        {results.map(post => (
          <Grid item xs={12} key={post.id} data-aos="fade-up" className={classes.gridItem}>
            <CardProduct
              className={classes.cardProduct}
              mediaContent={
                <Link href={`/blog/post/${post.uid}`}>
                  <a>
                    <Image
                      src={post.data?.cover?.url}
                      alt={post.data?.cover?.alt || RichText.asText(post.data?.title)}
                      width={200}
                      height={200}
                      objectFit="cover"
                      className={classes.image}
                    />
                  </a>
                </Link>
              }
              cardContent={
                <div className={classes.blogContent}>
                  <Link href={`/blog/post/${post.uid}`}>
                    <a>
                      <Typography
                        variant="body2"
                        color="textPrimary"
                        className={classes.blogTitle}
                        gutterBottom>
                        {RichText.asText(post.data?.title)}
                      </Typography>
                    </a>
                  </Link>
                  <Typography variant="caption" color="textPrimary" component="div">
                    <i>{post.data?.author?.data?.name}</i>
                  </Typography>
                  <Typography variant="caption" color="textSeccondary">
                    <FormattedDate value={post.data?.date} />
                  </Typography>
                </div>
              }
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

Latest.propTypes = {};
